import { Model } from 'core/model';

export default class MetricsResultModel extends Model {
  // this model may have a dimension named `id`, which should not be used as the ID
  get id() {
    return this.optimisticId;
  }
}
